import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 512 512" x="0px" y="0px">
      <g>
        <path
          fill="currentColor"
          d="M331.146,182.001c0-20.703-7.339-38.379-22.016-53.028 c-14.677-14.648-32.388-21.972-53.131-21.972s-38.454,7.324-53.131,21.972c-14.677,14.649-22.016,32.324-22.016,53.028 s7.339,38.379,22.016,53.028c14.677,14.649,32.388,21.972,53.131,21.972s38.454-7.324,53.131-21.972 C323.808,220.38,331.146,202.704,331.146,182.001L331.146,182.001z M406.293,182.001c0,21.289-3.229,38.77-9.686,52.442 L289.757,461.2c-3.131,6.446-7.779,11.523-13.943,15.235c-6.164,3.711-12.769,5.567-19.814,5.567 c-7.045,0-13.65-1.856-19.814-5.567c-6.164-3.711-10.714-8.789-13.65-15.235L115.394,234.442 c-6.458-13.672-9.686-31.152-9.686-52.442c0-41.406,14.677-76.757,44.031-106.054S214.513,32.002,256,32.002 s76.907,14.649,106.262,43.945S406.293,140.595,406.293,182.001L406.293,182.001z"></path>
      </g>
    </svg>
  );
};

export default Icon;
